/* istanbul ignore file */
import { fetch } from 'src/services/apollo-fetch';
import { Query, Mutation } from '../_api';

export default {
  async fetchBookingRequests({ commit }) {
    const response = await fetch.query({
      query: Query.bookingRequests,
    });
    commit('setBookingRequests', response.data.bookingRequests);
  },
  async updateBookingRequest({ commit }, data) {
    const response = await fetch.mutate({
      mutation: Mutation.updateBookingRequest,
      variables: { input: data },
    });
    commit('updateBookingRequest', { ...data, ...response.data.updateBookingRequest });
  },
};
